<!-- Error Views -->
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="gridItemChildModule w-100 h-100 d-flex flex-column" *ngIf="dataLoadSuccess && !noData">
    <!--  Search  -->
    <div *ngIf="!config.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!showFilter">
        <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="500" (ngModelChangeDebounced)="applyFilter()"
            placeholder="Search" cvLocalizedText langSection="Common" langKey="Search" />
        <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
    </div>

    <!-- Search cxone -->
    <div *ngIf="config.isCxOne && !noData" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
        <sol-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
            (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="500"></sol-text-input>
        <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
            <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
        </i>
        <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
            <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </i>
    </div>
    <sol-inline-notification *ngIf="isLimitNotificationShown" style="margin-top: 4px !important;" class="ml-2 mr-2"
        messageType="info" [messageData]="limitNotificationMessage" [show]="isLimitNotificationShown"
        (close)="closeLimitNotification()">
    </sol-inline-notification>
    <!-- grid -->
    <div class="h-100" style="overflow-y:auto" *ngIf="!noData">
        <ag-grid-angular 
            #contactListWidgetGrid
            *ngIf="gridOptions != null"
            class="ag-theme-balham flex-fill w-100 h-100"
            [gridOptions]="gridOptions"> 
        </ag-grid-angular>
    </div>
</div>
